import { Drawer } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AgencyIcon from "../../../components/icons/AgencyIcon";
import CloseIcon from "../../../components/icons/CloseIcon";
import DashboardIcon from "../../../components/icons/DashboardIcon";
import DesignTemplatesIcon from "../../../components/icons/DesignTemplatesIcon";
import Logo from "../../../components/icons/Logo";
import MyPropertiesIcon from "../../../components/icons/MyPropertiesIcon";
import SubscriptionsIcon from "../../../components/icons/SubscriptionsIcon";
import WorkspaceIcon from "../../../components/icons/WorkspaceIcon";
import { dashboardAction } from "../../../redux/features/dashboardSlice";
import { RootState } from "../../../redux/store";
import { clientRoutes } from "../../../utils/routes";
import { useLocation } from "react-router-dom";

import "./SideDrawer.scss";
import MainLogo from "../../../components/icons/MainLogo";
import AgentsIcon from "../../../components/icons/AgentsIcon";
import ReferralsIcon from "../../../components/icons/ReferralsIcon";
import RoyaltyIcon from "../../../components/icons/RoyaltyIcon";
import { LocalStorageHelpers } from "../../../utils/helpers/localstorage.helpers";

const SideDrawer = () => {
  const dispatch = useDispatch();
  let sideBar = useSelector((state: RootState) => state?.dashboard?.sideBar);
  const location = useLocation();

  const onClose = () => {
    dispatch(dashboardAction?.setsideBar());
  };

  const [userRole] = React.useState<"agent" | "agency">(() => {
    const storedRole = LocalStorageHelpers.getSessionUserType();
    return storedRole === "agent" || storedRole === "agency"
      ? storedRole
      : "agency";
  });

  const side_bar_item = getSidebarItems(userRole);

  return (
    <div className="side-drawer-container">
      <div className="web-drawer-container">
        <div className="side-bar-logo">
          <img
            src="/images/brand-bards-new-logo-with-background.png"
            alt="Brand Bards Logo"
          />
        </div>
        <div className="list_item_container">
          {side_bar_item.map((data) => (
            <Link key={data?.id} to={data?.link}>
              <div
                className={`item ${
                  `/${location?.pathname?.split("/")[1]}` == data?.link
                    ? "active-link"
                    : ""
                }`}
                key={data?.id}
              >
                <div className="item_icon">{data?.itemIcon}</div>
                <div className="item_name">
                  <p> {data?.itemName}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="mobile-drawer-container">
        <Drawer
          className="sidebar-drawer"
          classes={{
            paper: "sidebar-drawer-paper",
          }}
          open={sideBar}
          onClose={onClose}
          disablePortal={true}
        >
          <div className="mobile_top_contain">
            <div className="mobile-side-bar-logo">
              {/* <img src="./images/logo.svg" alt="" /> */}
              {/* <MainLogo /> */}
              <img
                src="/images/brand-bards-new-logo-with-background.png"
                alt="Brand Bards Logo"
              />
            </div>
            <div className="mobile-close-logo" onClick={onClose}>
              <CloseIcon />
            </div>
          </div>

          <div className="mobile-list_item_container">
            {side_bar_item.map((data) => (
              <Link key={data?.id} to={data?.link} onClick={onClose}>
                <div
                  className={`mobile-item ${
                    location.pathname === data?.link ? "active-link" : ""
                  }`}
                  key={data?.id}
                >
                  <div className="mobile-item_icon">{data?.itemIcon}</div>
                  <div className="mobile-item_name">
                    <p> {data?.itemName}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </Drawer>
      </div>
    </div>
  );
};

export default SideDrawer;

const getSidebarItems = (role: "agent" | "agency") => {
  return [
    {
      itemName: "Agents",
      itemIcon: <AgentsIcon />,
      id: "1",
      link: clientRoutes.agents,
    },
    ...(role === "agency"
      ? [
          {
            itemName: "Agency Employees",
            itemIcon: <AgentsIcon />,
            id: "2",
            link: clientRoutes.agencyEmployeeList,
          },
          {
            itemName: "Agent Employees",
            itemIcon: <AgentsIcon />,
            id: "2a",
            link: clientRoutes.agencyAgentEmployeeList,
          },
        ]
      : [
          {
            itemName: "Agent Employees",
            itemIcon: <AgentsIcon />,
            id: "2",
            link: clientRoutes.agentEmployeeList,
          },
        ]),
    {
      itemName: "Workspace",
      itemIcon: <WorkspaceIcon />,
      id: "3",
      link: clientRoutes?.workspace,
    },
    {
      itemName: "My Properties",
      itemIcon: <MyPropertiesIcon />,
      id: "4",
      link: clientRoutes.properties,
    },
    {
      itemName: "Subscriptions",
      itemIcon: <SubscriptionsIcon />,
      id: "5",
      link: clientRoutes.subscription,
    },
    ...(role === "agency"
      ? [
          {
            itemName: "Design Templates",
            itemIcon: <DesignTemplatesIcon />,
            id: "6",
            link: clientRoutes.designTemplates,
          },
        ]
      : []),
    // {
    //   itemName: "Referrals",
    //   itemIcon: <ReferralsIcon />,
    //   id: "7",
    //   link: "",
    // },
    // {
    //   itemName: "Royalty Program",
    //   itemIcon: <RoyaltyIcon />,
    //   id: "8",
    //   link: "",
    // },
    // {
    //   itemName: "Ledger",
    //   itemIcon: <AgentsIcon />,
    //   id: "9",
    //   link: clientRoutes.ledger,
    // },
    // {
    //   itemName: "Manage Subscriptions",
    //   itemIcon: <AgentsIcon />,
    //   id: "9",
    //   link: clientRoutes.manageSubscriptions,
    // },
    // {
    //   itemName: "Payment History",
    //   itemIcon: <AgentsIcon />,
    //   id: "10",
    //   link: clientRoutes.paymentHistory,
    // },
    // {
    //   itemName: "Dashboard",
    //   itemIcon: <DashboardIcon />,
    //   id: "6",
    //   link: "",
    // },
  ];
};
